import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Hospital, ChevronRight, Star, Inbox } from "lucide-react";
import { SyncStatus } from "@/components/OfflineBanner";
import { prefetchPickups } from "@/lib/prefetchPickups";

export default function ToRecover() {
  const nav = useNavigate();
  const [groups, setGroups] = useState(null);

  useEffect(() => {
    const load = () => api.get("/requests/grouped").then((r) => { setGroups(r.data.groups); if (!r.fromCache) prefetchPickups(); }).catch(() => setGroups((g) => g || []));
    load();
    window.addEventListener("sanitdocs:resync", load);
    return () => window.removeEventListener("sanitdocs:resync", load);
  }, []);

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-heading font-extrabold text-brand-900">Documents à récupérer</h1>
      <p className="text-slate-400 text-sm -mt-2">Uniquement les documents récupérables aujourd'hui.</p>
      <SyncStatus />

      {groups === null && <p className="text-slate-400 py-10 text-center">Chargement…</p>}
      {groups && groups.length === 0 && (
        <div className="text-center py-16 text-slate-400">
          <Inbox className="w-12 h-12 mx-auto mb-3 text-slate-300" />
          <p className="font-semibold">Aucun document à récupérer aujourd'hui</p>
        </div>
      )}

      <div className="space-y-3">
        {groups?.map((g) => (
          <button key={g.establishment_id} data-testid={`est-group-${g.establishment_id}`}
            onClick={() => nav(`/driver/etablissement/${g.establishment_id}`)}
            className="w-full bg-white rounded-2xl border border-slate-200 border-l-4 border-l-brand-700 p-5 flex items-center gap-4 shadow-sm active:scale-[0.98] transition-transform text-left">
            <div className="w-14 h-14 rounded-xl bg-brand-50 text-brand-700 flex items-center justify-center shrink-0">
              <Hospital className="w-7 h-7" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-lg font-heading font-bold text-brand-900 leading-tight flex items-center gap-1.5 min-w-0">
                <span className="leading-snug">{g.establishment_name}</span>
                {g.favorite && <Star className="w-4 h-4 text-accent-500 fill-accent-500 shrink-0" />}
              </p>
              <p className="text-sm text-slate-400 truncate">{g.city ? `${g.city} · ` : ""}{g.count} document{g.count > 1 ? "s" : ""}</p>
            </div>
            <div className="flex items-center gap-2">
              <span className="min-w-8 h-8 px-2 rounded-full bg-brand-700 text-white text-sm font-bold flex items-center justify-center">{g.count}</span>
              <ChevronRight className="w-6 h-6 text-slate-300" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
